import React from "react";
import { SmartLink } from "@/src/components/v2/SmartLink/SmartLink";
import { PublicSettings } from "@/src/config/PublicSettings";
import { BrandService } from "@/src/BrandService";

const Copy = () => {
    const BRAND_DATA = BrandService.getCurrentBrandData();

    // Opens the Osano "Do Not Sell or Share My Personal Information" modal.
    // Osano is injected globally via pages/_document.tsx; guard in case it
    // hasn't loaded yet (e.g. blocked by a network/ad-blocker).
    const handleDoNotSell = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        window.Osano?.cm?.showDoNotSell();
    };

    return (
        <div className="flex flex-col gap-5 text-xs text-text-contrast">
            {/* py-1 makes 24px touch targets; the gap and -my-1 absorb it so the text doesn't move */}
            <div className="-my-1 flex flex-col md:flex-row md:gap-2">
                <SmartLink href="/ca-notice" className="py-1 underline">
                    NOTICE TO CALIFORNIA RESIDENTS
                </SmartLink>
                <SmartLink href="/important-policy-provisions" className="py-1 underline">
                    Insurer Disclosure of Important Policy Provisions
                </SmartLink>
            </div>
            <p>
                Waiting periods, annual deductible, co-insurance, benefit limits and exclusions may apply. For all terms visit&nbsp;
                <a href="/sample-policy" target="_blank" rel="noopener noreferrer">
                    {PublicSettings.CANONICAL_URL_ROOT}/sample-policy
                </a>
                . Products, schedules, discounts, and rates may vary and are subject to change. 10% multi-pet discount is available on all pets after the first. More information
                available at checkout.
                <br />
                Insurance plans are underwritten by either Independence American Insurance Company (NAIC #26581. A Delaware insurance company located at 11333 N. Scottsdale Rd,
                Ste. 160, Scottsdale, AZ 85254) or United States Fire Insurance Company (NAIC #21113. Morristown, NJ), and are produced by Spot Pet Insurance Services, LLC. (NPN #
                19246385. {BRAND_DATA.streetAddress}, {BRAND_DATA.addressLocality}, {BRAND_DATA.addressRegion} {BRAND_DATA.postalCode}. CA License #6000188).
            </p>

            <p>
                Premiums are based on the current age of your pet. Premium may increase due to the age of your pet at renewal. Initial premiums may be impacted by the species or
                breed of your pet. Premium may change based on your home address.
            </p>

            <p>
                ^ Advertised premium is based on an accident and illness plan with an 80% reimbursement rate, $500 annual deductible, and a $2,500 annual limit for a 2-year-old
                small mixed dog (11-25lbs) in 32009. Plan costs vary.
            </p>

            <p>
                ^^ Advertised premium is based on an accident and illness plan with an 80% reimbursement rate, $750 annual deductible, and a $2,500 annual limit for a 2-year-old
                mixed cat in 33801. Plan costs vary.
            </p>

            <p>
                ° Includes up to 10% group discount plus up to 10% multi-pet discount on 2nd+ pets. Discounts vary by state and are subject to change. Not available in all states.
            </p>

            <div className="">© {new Date().getFullYear()} Spot Pet Insurance Services, LLC. All Rights Reserved.</div>
            <div className="-my-1 flex flex-row flex-wrap gap-x-4 gap-y-2">
                <SmartLink href="/terms-conditions" className="py-1 underline">
                    Terms &amp; Conditions
                </SmartLink>
                <SmartLink href="/privacy" className="py-1 underline">
                    Privacy Policy
                </SmartLink>
                <button type="button" onClick={handleDoNotSell} className="cursor-pointer py-1 text-left underline">
                    Do Not Sell or Share My Personal Information
                </button>
            </div>
        </div>
    );
};

export default Copy;
